import * as React from "react";
import { listUserCompletedRequest } from "../../../../Service/ApiService";
import AuthenticationService from "../../../../Service/AuthenticationService";
import GlobalDataGrid from "./../AllRequestDataGrid";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const CompletedRequestDataGrid = (props: any) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const listOfRequest = async () => {
    return listUserCompletedRequest(
      AuthenticationService.email,
      AuthenticationService.token,
      AuthenticationService.company
    )
      .then((newData: any) => {
        return newData;
      })
      .catch((error) => {
        enqueueSnackbar(t("error.errorHasOccured"), {
          variant: "error",
        });
        console.error(error);
      });
  };

  return (
    <GlobalDataGrid
      listOfRequest={listOfRequest}
      createNewRequest={props.changeCurrentPage}
      origin="CompletedRequest"
      updateNotification={props.updateNotification}
      originOfUpdate="noUpdate"
    />
  );
};

export default CompletedRequestDataGrid;
